document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".LP_collection_slider")) {
    /* LP_collection_slider */
    new Swiper(".LP_collection_slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 16,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      observer: true,
      observeParents: true,
      freeMode: !0,
      breakpoints: {
        0: {
          spaceBetween: 12,
        },
        769: {
          spaceBetween: 16,
        },
        992: {},
        1200: {},
        1440: {},
      },
    });
  }

  if (document.querySelector(".LP_testimonials_slider")) {
    /* LP_testimonials_slider */
    new Swiper(".LP_testimonials_slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 24,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      observer: true,
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      freeMode: !0,
      breakpoints: {
        0: {
          spaceBetween: 12,
          freeMode: !1,
        },
        769: {
          spaceBetween: 24,
          freeMode: !0,
        },
        992: {},
        1200: {},
        1440: {},
      },
    });
  }
  if (document.querySelector(".LP_product_tab_slider")) {
    /* LP_product_tab_slider */
    new Swiper(".LP_product_tab_slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 80,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      observer: true,
      observeParents: true,
      freeMode: !0,
      breakpoints: {
        0: {
          spaceBetween: 20,
        },
        769: {
          spaceBetween: 30,
        },
        992: {
          spaceBetween: 50,
        },
        1200: {
          spaceBetween: 80,
        },
        1440: {},
      },
    });
  }

  if (document.querySelector(".pi-dealers-tab-slider")) {
    /* Dealers_tabs_slider */
    new Swiper(".pi-dealers-tab-slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 28,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          spaceBetween: 24,
        },
        769: {
          spaceBetween: 28,
        },
        992: {
          spaceBetween: 28,
        },
        1200: {
          spaceBetween: 28,
        },
        1440: {
          freeMode: !0,
        },
      },
    });
  }

  if (document.querySelector(".Dealers_testimonial_slider")) {
    /* Dealers_testimonial_slider */
    new Swiper(".Dealers_testimonial_slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 17,
      slidesPerGroup: 1,
      slidesPerView: 4,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          spaceBetween: 10,
          slidesPerGroup: 1,
          slidesPerView: 1,
          autoHeight: !0,
        },
        769: {
          spaceBetween: 17,
          slidesPerGroup: 1,
          slidesPerView: 2,
          autoHeight: !0,
        },
        992: {
          spaceBetween: 17,
          slidesPerGroup: 1,
          slidesPerView: 3,
          autoHeight: !0,
        },
        1200: {
          spaceBetween: 17,
          slidesPerGroup: 1,
          slidesPerView: 4,
          autoHeight: !1,
        },
        1440: {
          freeMode: !0,
        },
      },
    });
  }

  if (document.querySelector(".Dealers_reviews_slider")) {
    /* Dealers_reviews_slider */
    new Swiper(".Dealers_reviews_slider", {
      loop: false,
      grabCursor: false,
      spaceBetween: 16,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      mousewheel: {
        forceToAxis: !0,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
        },
        769: {
          spaceBetween: 16,
        },
        992: {
          spaceBetween: 16,
        },
        1200: {
          spaceBetween: 16,
        },
        1440: {
          freeMode: !0,
        },
      },
    });
  }

  if (document.querySelector(".team__slider")) {
    new Swiper(".team__slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        340: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 3.2,
        },
      },
    });
  }


  if (document.querySelector(".rider-reviews-swiper")) {
    new Swiper(".rider-reviews-swiper", {
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
      },
      observer: true,
      observeParents: true,
      breakpoints: {
          0: {
              spaceBetween: 2,
          },
          769: {
              spaceBetween: 2,
          },
          992: {
              spaceBetween: 2,
          },
          1200: {
              spaceBetween: 2,
          },
          1440: {
              freeMode: true,
          }
      }
  });
  }
});
